import { HarmonyThemeId, HarmonyThemeMode, } from '@office-start/visual-types';
export var DefaultHarmonyTheme = {
    id: HarmonyThemeId.Office,
    lastModifiedTimeUtc: Date.now(),
    mode: HarmonyThemeMode.System,
    preferHarmonyTheme: false,
    version: 1,
};
//# sourceMappingURL=DefaultHarmonyTheme.js.map